"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmoothScroll = void 0;
var _react = _interopRequireWildcard(require("react"));
var _all = require("gsap/all");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
_all.gsap.registerPlugin(_all.ScrollTrigger);
const GalleryItem = ({
  index,
  src,
  srcSet
}) => {
  const isEven = index % 2;
  return _react.default.createElement(_styles.ImageContainer, {
    isEven: isEven
  }, _react.default.createElement(_styles.ImageWrapper, null, _react.default.createElement(_styles.Image, {
    src: src,
    srcSet: srcSet,
    alt: src
  })));
};
const SmoothScroll = ({
  items
}) => {
  return _react.default.createElement("div", null, items.map((item, index) => _react.default.createElement(GalleryItem, _extends({
    key: `smooth-scroll-item--${index}`,
    index: index
  }, item))));
};
exports.SmoothScroll = SmoothScroll;
//# sourceMappingURL=index.js.map